import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { PagePath } from '@monorepo/client-types';
import { BlockedBy } from '@monorepo/types';
import { useStore } from '../../helpers/use-store';

interface BlacklistGuardProps {
  children: React.ReactNode;
}

const BlacklistGuard: React.FC<BlacklistGuardProps> = ({ children }) => {
  const {
    dataStore: { applicationConfigStore },
  } = useStore();

  const isBlacklisted =
    applicationConfigStore.applicationConfig.isBlacklisted &&
    applicationConfigStore.applicationConfig.blockedBy ===
      BlockedBy.FailedPaymentRule;

  if (isBlacklisted) {
    return <Navigate to={PagePath.Blacklisted} replace />;
  }

  return <>{children}</>;
};

export default observer(BlacklistGuard);
